
(function loadingModuleDefinition() {

    'use strict';

    angular.module('Loading', []);

})();